<div class="d-flex flex-wrap justify-content-center align-items-center mt-2">
  <div class="logoBrandLogin"></div>
</div>
<div class="d-flex flex-wrap justify-content-center align-items-center mt-2">
  <h2 class="mb-4 mt-3">{{'lang.globals.error' | translate}}</h2>
</div>
<div class="d-flex flex-wrap justify-content-center align-items-center">
  <h1 class="mb-4 mt-3">{{ status }} - {{ getReasonPhrase() }}</h1>
</div>
<div *ngIf="error" class="d-flex flex-wrap justify-content-center align-items-center">
  <h3 class="mb-4 mt-3">{{ error?.error?.message }}</h3>
</div>
<div *ngIf="error" style="opacity: 0.5; overflow-wrap: anywhere"
     class="d-flex justify-content-center align-items-center mt-5">
  {{error?.error?.error}}
</div>
<div style="opacity: 0.5" class="d-flex flex-wrap justify-content-center align-items-center mt-5">
    <span class="mr-2">
        {{getBackendName()}} {{getBackendVersion() ? getBackendVersion() : '???'}}
    </span>
  <span class="d-none d-sm-block">
        ||
    </span>
  <span class="ml-2">
        {{getFrontendName()}} {{getFrontendVersion() ? getFrontendVersion() : '???'}}
    </span>
</div>
